import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { DatePicker, Form, Modal } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import dayjs from "dayjs";
const FuelLevyDateModal = ({ open, fuelLevy, onSuccess, onCancel }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (open && fuelLevy) {
            const effectiveFrom = fuelLevy.effectiveFrom ? dayjs(fuelLevy.effectiveFrom) : null;
            const effectiveTo = fuelLevy.effectiveTo ? dayjs(fuelLevy.effectiveTo) : null;
            form.setFieldsValue({
                effectiveFrom,
                effectiveTo
            });
        }
    }, [open]);
    const save = (formValues) => {
        setLoading(true);
        const request = {
            effectiveTo: formValues.effectiveTo,
        };
        axios.put(`/admin/v1/fuel-levies/${fuelLevy.id}`, request)
            .then((response) => onSuccess(response.data))
            .catch(axiosErrorHandler)
            .finally(() => setLoading(false));
    };
    return (_jsx(Modal, { title: "Edit Fuel Levy Effective Date Range", open: open, onOk: form.submit, onCancel: onCancel, confirmLoading: loading, children: _jsxs(Form, { layout: "vertical", onFinish: save, form: form, children: [_jsx(Form.Item, { name: "effectiveFrom", label: "Effective From", rules: [{
                            required: true,
                            message: 'Please a date and time ',
                        }], children: _jsx(DatePicker, { disabled: true, showTime: true, showNow: false, format: "DD/MM/YYYY HH:mm", style: {
                            width: "100%"
                        }, minuteStep: 5 }) }), _jsx(Form.Item, { name: "effectiveTo", label: "Effective To", children: _jsx(DatePicker, { showTime: true, presets: [
                            { label: 'Midnight Tonight', value: dayjs().add(1, 'day').hour(0).minute(0).second(0) }
                        ], showNow: true, format: "DD/MM/YYYY HH:mm", style: {
                            width: "100%"
                        }, minuteStep: 5 }) })] }) }));
};
export default FuelLevyDateModal;
